import { BookingFormValues } from 'Common/components/BookingForm';
import { BookingFormCustomerInputs } from 'Common/context/BookingFormContextProvider/types';
import {
  calculateTotalsForCustomerInputSelections,
} from 'Common/functions/BookingForm';
import { V2Gateway_GetCustomerInputsByUidQueryHookResult } from 'Generated/graphql';
import { UseServiceOfferings } from '../useServiceOfferings';

type cis = BookingFormCustomerInputs | undefined
type ciSelections = Pick<NonNullable<BookingFormValues['customerInputSelections']>[number], 'customerInputUid' | 'optionValue'>[]
type gciSelections = BookingFormValues['customerInputGroupSelections']
type gcis = NonNullable<
    V2Gateway_GetCustomerInputsByUidQueryHookResult['data']
  >['getCustomerInputsByUid'] | undefined
type so = Pick<UseServiceOfferings[number], 'uid' | 'basePrice' | 'baseTime'>
type directCustomerInputs = Pick<NonNullable<cis>[number], 'uid' | 'options' | 'unitPrice' | 'type'>[]

export const calculateTotalsForServiceOfferingAndCustomerInputSelections = (
  directCustomerInputs: directCustomerInputs,
  groupCustomerInputs: NonNullable<gcis>,
  selectedOffering: so | undefined,
  directSelections: ciSelections,
  groupSelections: gciSelections,
) => {
  let newTotalPrice = 0;
  let newTotalDuration = 0;
  if (!selectedOffering || !directCustomerInputs || !groupCustomerInputs) {
    return [0, 0];
  }

  newTotalPrice = selectedOffering.basePrice;
  newTotalDuration = selectedOffering.baseTime;

  const allCustomerInputs = directCustomerInputs.concat(groupCustomerInputs);

  const [
    selectionsTotalPrice, selectionsTotalDuration
  ] = calculateTotalsForCustomerInputSelections(
    directSelections,
    groupSelections,
    allCustomerInputs,
  );
  newTotalPrice += selectionsTotalPrice;
  newTotalDuration += selectionsTotalDuration;

  return [newTotalPrice, newTotalDuration];
};

